// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"39e7871c","160":"3abecfc9","352":"32ae856d","392":"4bc883f1","451":"7485e85a","518":"d34abe96","996":"98921c51"}[chunkId] + ".chunk.js";
};